/* Carrusel automatico de "Amigos de la casa" (2026-09-21).
 *
 * Mueve el carrusel solo, en loop, sin romper nada de lo que ya habia:
 * sigue siendo un contenedor con overflow-x, asi que el arrastre con el
 * mouse y el swipe en celular andan igual que antes.
 *
 * Como hace el loop sin saltos: duplica las tarjetas una vez. Cuando el
 * scroll pasa la mitad del recorrido, le resta esa mitad de golpe. Como en
 * esa posicion se esta viendo contenido identico, el salto es invisible.
 *
 * Se detiene cuando corresponde: con el boton de pausa, con el foco del
 * teclado adentro, mientras el visitante arrastra, y con la pestana en
 * segundo plano. NO se detiene al pasar el cursor por encima. Tampoco
 * arranca si el sistema pide menos animaciones o si las tarjetas entran
 * todas en pantalla.
 *
 * OJO -- la posicion se lleva en una variable aparte (posicion) y NO se lee
 * de vuelta de scrollLeft en cada cuadro. Leer scrollLeft devuelve el valor
 * redondeado, asi que a 28 px/s (menos de medio pixel por cuadro) el
 * incremento se perdia en el redondeo y el carrusel quedaba clavado.
 * Verificado el 2026-09-21: avanzaba 0 px en 3 segundos.
 */
(function () {
  "use strict";

  var VELOCIDAD = 52;       // px por segundo
  var PAUSA_TRAS_TOQUE = 1800; // ms de gracia despues de que el visitante mueve el carrusel
  var RESENA_TAM_MAX = 22;  // px, el tamano de diseno
  var RESENA_TAM_MIN = 12;  // px, hasta donde se acepta achicar para que entre
  var RESENA_COLCHON = 8;   // px que se dejan libres al final de la linea

  /* Deja cada resena en UNA sola linea.
   *
   * No se puede con CSS solo: las frases miden entre 278 y 537 px y en la
   * tarjeta entran 326. Poner un tamano fijo que le entre a la mas larga
   * obligaria a bajar TODAS a 13px, y la mayoria no lo necesita. Asi que se
   * achica una por una, solo lo que haga falta, arrancando del tamano de
   * diseno.
   *
   * Si ni siquiera con el minimo entra, se deja que corte en dos lineas:
   * mejor dos lineas legibles que una ilegible.
   *
   * DOS COSAS QUE HACEN FALTA PARA QUE LA MEDIDA SEA REAL:
   *
   * 1. Esperar a document.fonts.ready. Si se mide antes, el navegador
   *    todavia esta usando la tipografia de reemplazo, que es mas angosta
   *    que PP Neue Montreal: da que entra, despues entra la buena, el texto
   *    crece y queda cortado. Fue lo que paso con las resenas de Pedro
   *    Perez DiSalvo y Manu Armoa (2026-09-21).
   *
   * 2. Dejar un colchon al final. Sin el, el ajuste frena apenas entra y
   *    quedaban 2 px de aire: cualquier diferencia de render entre maquinas
   *    (macOS dibuja el texto un poco mas ancho que este entorno de prueba)
   *    se lo come y corta la ultima letra.
   *
   * OJO CON CONTRA QUE SE MIDE -- .cont-text esta posicionado en absoluto
   * sin ancho, asi que al poner nowrap la propia caja se estira para
   * albergar el texto. Si se mide su clientWidth DESPUES del nowrap,
   * siempre da que entra y el texto termina desbordando la tarjeta y
   * cortado por el overflow del figure. El ancho tiene que salir de la
   * TARJETA menos el padding. Pasado el 2026-09-21: las 14 resenas daban
   * "entra" a 22px cuando la mas larga mide 537 px y la tarjeta 326.
   */
  function ajustarResenas(seccion) {
    var parrafos = seccion.querySelectorAll(".cont-text p");
    Array.prototype.forEach.call(parrafos, function (p) {
      var caja = p.parentElement;
      var tarjeta = p.closest(".categoria-destacada-item");
      if (!caja || !tarjeta) return;

      var cs = window.getComputedStyle(caja);
      var disponible = tarjeta.clientWidth
        - parseFloat(cs.paddingLeft || 0)
        - parseFloat(cs.paddingRight || 0)
        - RESENA_COLCHON;
      if (!(disponible > 0)) return;

      p.style.whiteSpace = "nowrap";
      var tam = RESENA_TAM_MAX;
      p.style.fontSize = tam + "px";
      while (p.scrollWidth > disponible && tam > RESENA_TAM_MIN) {
        tam -= 0.5;
        p.style.fontSize = tam + "px";
      }
      if (p.scrollWidth > disponible) {
        // No entro ni con el minimo: se vuelve a dos lineas.
        p.style.whiteSpace = "";
        p.style.fontSize = "";
      }
    });
  }

  function iniciar(seccion) {
    var pista = seccion.querySelector(".signatures-home-cont");
    if (!pista) return;

    var originales = Array.prototype.slice.call(pista.children);
    if (originales.length < 2) return;

    // Si entra todo en pantalla no hay nada que desplazar.
    if (pista.scrollWidth <= pista.clientWidth + 1) return;

    var menosMovimiento = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (menosMovimiento.matches) return;

    // Duplicado para el loop. aria-hidden + tabindex -1 para que los
    // lectores de pantalla y el tabulador vean cada resena una sola vez.
    originales.forEach(function (nodo) {
      var clon = nodo.cloneNode(true);
      clon.classList.add("amigos-clon");
      clon.setAttribute("aria-hidden", "true");
      Array.prototype.forEach.call(clon.querySelectorAll("a, button, input"), function (foco) {
        foco.setAttribute("tabindex", "-1");
      });
      pista.appendChild(clon);
    });

    seccion.classList.add("amigos-auto");

    var pausado = false;
    var manual = false;       // lo freno el visitante con el boton
    var reanudarEn = 0;
    var ultimo = null;
    var pedido = null;
    var posicion = pista.scrollLeft;

    function mitad() {
      // La mitad del recorrido total: el ancho de la lista original.
      return pista.scrollWidth / 2;
    }

    function paso(ahora) {
      if (ultimo === null) ultimo = ahora;
      var delta = (ahora - ultimo) / 1000;
      ultimo = ahora;

      // Una pestana en segundo plano puede devolver un delta enorme al
      // volver; se acota para que el carrusel no pegue un tiron.
      if (delta > 0.1) delta = 0.1;

      var enEspera = pausado || ahora < reanudarEn;
      if (!enEspera) {
        posicion += VELOCIDAD * delta;
        if (posicion >= mitad()) posicion -= mitad();
        pista.scrollLeft = posicion;
      }
      pedido = window.requestAnimationFrame(paso);
    }

    function arrancar() {
      if (pedido === null) {
        ultimo = null;
        pedido = window.requestAnimationFrame(paso);
      }
    }
    function frenar() {
      if (pedido !== null) {
        window.cancelAnimationFrame(pedido);
        pedido = null;
      }
    }

    // NO se pausa al pasar el cursor por encima (cambio pedido el
    // 2026-09-24). Antes frenaba con el cursor sobre una tarjeta; ahora
    // sigue andando y, si a alguien le molesta, lo frena con el boton.

    // El foco del teclado si lo frena: alguien que llega tabulando necesita
    // que el contenido se quede quieto para poder leerlo.
    seccion.addEventListener("focusin", function (e) {
      if (e.target !== boton) pausado = true;
    });
    seccion.addEventListener("focusout", function (e) {
      if (e.target !== boton && !manual) pausado = false;
    });

    // Mientras el visitante mueve el carrusel a mano, el automatico se corre
    // a un costado un momento en vez de pelearle.
    ["pointerdown", "touchstart"].forEach(function (evento) {
      pista.addEventListener(evento, function () {
        reanudarEn = performance.now() + PAUSA_TRAS_TOQUE;
      }, { passive: true });
    });

    // OJO CON LA RUEDA -- solo cuenta si es HORIZONTAL. Antes se tomaba
    // cualquier rueda, asi que bajar la pagina con el cursor encima del
    // carrusel lo frenaba 1,8 segundos, y como uno sigue scrolleando parecia
    // que se detenia con solo pasar el mouse por arriba. Reportado el
    // 2026-09-24.
    pista.addEventListener("wheel", function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        reanudarEn = performance.now() + PAUSA_TRAS_TOQUE;
      }
    }, { passive: true });

    // Cuando el movimiento lo hizo el visitante, hay que volver a tomar la
    // posicion real: si no, al reanudar el carrusel pegaria un salto hasta
    // donde estaba el automatico.
    pista.addEventListener("scroll", function () {
      if (pausado || performance.now() < reanudarEn) posicion = pista.scrollLeft;
    }, { passive: true });

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { frenar(); } else { arrancar(); }
    });

    menosMovimiento.addEventListener("change", function (e) {
      if (e.matches) { frenar(); } else { arrancar(); }
    });

    var boton = crearBoton(seccion, function () {
      manual = !manual;
      pausado = manual;
      return manual;
    });

    arrancar();
  }

  /* Boton de pausa.
   *
   * Se crea desde el JS y no desde el Liquid a proposito: si el script no
   * corre -- porque el visitante pidio menos animaciones, o porque las
   * tarjetas entran todas en pantalla y no hay nada que desplazar -- el
   * carrusel no se mueve y un boton de pausa no tendria sentido. Creandolo
   * aca, el boton existe solo cuando existe el movimiento.
   */
  function crearBoton(seccion, alPulsar) {
    var boton = document.createElement("button");
    boton.type = "button";
    boton.className = "amigos-pausa";
    boton.setAttribute("aria-pressed", "false");
    boton.setAttribute("aria-label", "Pausar el carrusel");
    boton.innerHTML = ICONO_PAUSA;

    boton.addEventListener("click", function () {
      var frenado = alPulsar();
      boton.setAttribute("aria-pressed", frenado ? "true" : "false");
      boton.setAttribute("aria-label", frenado ? "Reanudar el carrusel" : "Pausar el carrusel");
      boton.innerHTML = frenado ? ICONO_PLAY : ICONO_PAUSA;
    });

    var titulo = seccion.querySelector("h3");
    if (titulo && titulo.parentElement) {
      titulo.parentElement.appendChild(boton);
      titulo.parentElement.classList.add("amigos-encabezado");
    } else {
      seccion.appendChild(boton);
    }
    return boton;
  }

  var ICONO_PAUSA =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
    'stroke-linecap="round" aria-hidden="true"><path d="M9 4v16"/><path d="M15 4v16"/></svg>';
  var ICONO_PLAY =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M7.6 4.6a1.1 1.1 0 0 1 1.67-.94l10.2 7.4a1.1 1.1 0 0 1 0 1.88l-10.2 7.4A1.1 1.1 0 0 1 7.6 19.4z"/></svg>';

  function listo() {
    var seccion = document.getElementById("amigos-de-la-casa");
    if (!seccion || seccion.dataset.amigosCarrusel === "listo") return;
    seccion.dataset.amigosCarrusel = "listo";
    // Un respiro para que el tema termine de medir (la barra de scroll
    // propia se inicializa con un setTimeout en custom.js).
    window.setTimeout(function () {
      iniciar(seccion);
      // Despues de iniciar(), asi agarra tambien las copias del loop.
      ajustarResenas(seccion);
      // Y de nuevo cuando las tipografias esten listas: recien ahi las
      // medidas son las definitivas.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { ajustarResenas(seccion); });
      }
    }, 400);

    // Al cambiar el ancho cambia lo que entra en una linea.
    var pendiente = null;
    window.addEventListener("resize", function () {
      window.clearTimeout(pendiente);
      pendiente = window.setTimeout(function () { ajustarResenas(seccion); }, 200);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", listo);
  } else {
    listo();
  }
})();
